import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ExploreOffIcon from '@mui/icons-material/ExploreOff';
import { DEFAULT_GRADIENT, DEFAULT_GRADIENT_HOVER } from "../../constants/theme";
import useTranslation from "../../customHooks/translations";

const Error404View = () => {
  const translation = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0d1b2a 0%, #091420 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        textAlign: 'center',
      }}
    >
      <ExploreOffIcon sx={{ fontSize: { xs: 80, sm: 110 }, color: 'rgba(255,255,255,0.07)', mb: 3 }} />

      <Typography
        variant="h1"
        sx={{
          fontWeight: 900,
          fontSize: { xs: '6rem', sm: '9rem' },
          lineHeight: 1,
          background: DEFAULT_GRADIENT,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          mb: 1,
        }}
      >
        404
      </Typography>

      <Typography
        variant="h5"
        sx={{ color: 'white', fontWeight: 700, mb: 1.5, fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
      >
        Page Not Found
      </Typography>

      <Typography
        sx={{ color: 'rgba(255,255,255,0.5)', mb: 4, maxWidth: 380, fontSize: 15 }}
      >
        {translation.errors.error404Message}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/freak')}
          sx={{
            background: DEFAULT_GRADIENT,
            color: 'white',
            fontWeight: 700,
            borderRadius: 2,
            px: 4,
            '&:hover': { background: DEFAULT_GRADIENT_HOVER },
            '&:focus': { outline: 'none' },
          }}
        >
          Go Home
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate(-1)}
          sx={{
            borderColor: 'rgba(255,255,255,0.25)',
            color: 'rgba(255,255,255,0.7)',
            fontWeight: 700,
            borderRadius: 2,
            px: 4,
            '&:hover': { borderColor: 'rgba(255,255,255,0.5)', color: 'white' },
            '&:focus': { outline: 'none' },
          }}
        >
          Go Back
        </Button>
      </Box>
    </Box>
  );
};

export default Error404View;
